// 채팅에 붙여 넣은 주소를 눌러서 들어갈 수 있게, 본문을 글자 조각과 링크 조각으로 나눈다.
// 데스크톱(MessageBody)과 모바일(MentionText)이 같은 결과를 그리도록 양쪽이 이걸 쓴다.

// http/https 만 링크로 만든다. 남이 올린 글이 그대로 들어오는 자리라 javascript: 나 data: 는
// 절대 href 에 넣지 않는다.
const URL_PATTERN = /https?:\/\/[^\s<>"'`\\]+/gi;

// 주소 뒤에 그냥 붙어 있는 문장 부호는 주소가 아니다: "자세한 건 https://example.com/a. 여기"
const TRAILING_PUNCTUATION = '.,!?;:…"\'«»';
const CLOSERS = { ')': '(', ']': '[', '}': '{' };

function countOf(value, character) {
  let count = 0;
  for (const letter of value) if (letter === character) count += 1;
  return count;
}

function trimTrailing(raw) {
  let url = raw;
  for (;;) {
    const last = url.slice(-1);
    if (!last) return url;
    if (TRAILING_PUNCTUATION.includes(last)) {
      url = url.slice(0, -1);
      continue;
    }
    // 괄호는 주소 안에서 짝이 맞으면 남긴다: .../Foo_(bar)
    const opener = CLOSERS[last];
    if (opener && countOf(url, last) > countOf(url, opener)) {
      url = url.slice(0, -1);
      continue;
    }
    return url;
  }
}

export function safeChatLinkHref(url) {
  try {
    const parsed = new URL(String(url || ''));
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : '';
  } catch {
    return '';
  }
}

// [{ type: 'text', value }, { type: 'link', value, href }] 를 돌려준다. value 는 본문에 적힌
// 그대로라 눌러서 가는 곳과 눈에 보이는 글자가 어긋나지 않는다.
export function splitChatMessageLinks(body) {
  const source = String(body ?? '');
  if (!source) return [];

  const parts = [];
  let cursor = 0;
  for (const match of source.matchAll(URL_PATTERN)) {
    const url = trimTrailing(match[0]);
    const href = safeChatLinkHref(url);
    if (!href) continue;
    if (match.index > cursor) parts.push({ type: 'text', value: source.slice(cursor, match.index) });
    parts.push({ type: 'link', value: url, href });
    cursor = match.index + url.length;
  }
  if (cursor < source.length) parts.push({ type: 'text', value: source.slice(cursor) });
  return parts;
}
